import { post } from "@insite/client-framework/Services/ApiService";
import { CalculateRailParameter } from "@thkStore/Types/CalculateRailParameter";
import { CalculateRailResult } from "@thkStore/Types/CalculateRailResult";

export function calculateRail(
    parameter: CalculateRailParameter,
): Promise<CalculateRailResult> {
    return post<CalculateRailParameter, CalculateRailResult>(
        "/api/v1/railconfigurator/calculate",
        parameter,
    );
}
